import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import {
  ExpandMoreRounded as ExpandIcon,
  SettingsOutlined as MasterlistIcon,
} from "@mui/icons-material";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import { useSelector } from "react-redux";

const masterlistItemsConfig = [
  { label: "User Accounts", to: "/masterlist/users" },
  { label: "Treasuries", to: "/masterlist/treasuries" },
  { label: "Debit Requestors", to: "/masterlist/debit-requestors" },
  { label: "General Journal Approvers", to: "/masterlist/general-journal-approvers" },
  { label: "Organization Departments", to: "/masterlist/organization-departments" },
  { label: "Categories", to: "/masterlist/categories" },
  { label: "Document Types", to: "/masterlist/document-types" },
  { label: "Book of Accounts", to: "/masterlist/book-of-accounts" },
  { label: "Voucher Codes", to: "/masterlist/voucher-codes" },
  { label: "One Charging", to: "/masterlist/one-charging" },
  {
    label: "COA",
    items: [
      { label: "Companies", to: "/masterlist/companies" },
      { label: "Business Units", to: "/masterlist/business-unit" },
      { label: "Departments", to: "/masterlist/departments" },
      { label: "Units", to: "/masterlist/department-units" },
      { label: "Sub Units", to: "/masterlist/sub-unit" },
      { label: "Locations", to: "/masterlist/locations" },
    ],
  },
  {
    label: "Supplier Entries",
    items: [
      { label: "References", to: "/masterlist/references" },
      { label: "Urgency Types", to: "/masterlist/supplier-types" },
      { label: "Suppliers", to: "/masterlist/suppliers" },
    ],
  },
  {
    label: "Utility Entries",
    items: [
      { label: "Utility Categories", to: "/masterlist/utility-categories" },
      { label: "Utility Locations", to: "/masterlist/utility-locations" },
      { label: "Utility Accounts", to: "/masterlist/account-numbers" },
    ],
  },
  {
    label: "Accounting Entries",
    items: [
      { label: "Account Types", to: "/masterlist/account-types" },
      { label: "Account Groups", to: "/masterlist/account-groups" },
      { label: "Account Subgroups", to: "/masterlist/account-subgroups" },
      { label: "Financial Statements", to: "/masterlist/financial-statements" },
      { label: "Normal Balances", to: "/masterlist/normal-balances" },
      { label: "Units", to: "/masterlist/units" },
      { label: "Account Titles", to: "/masterlist/account-titles" },
    ],
  },
  { label: "Credit Cards", to: "/masterlist/credit-cards" },
  { label: "Payroll Clients", to: "/masterlist/payroll-clients" },
  { label: "Payroll Categories", to: "/masterlist/payroll-categories" },
  { label: "Banks", to: "/masterlist/banks" },
  { label: "Bank Series", to: "/masterlist/bank-series" },
  { label: "Reasons", to: "/masterlist/reasons" },
];

const SidebarMasterlistDropdown = ({ RouterLink, user, activeDropdown }) => {
  const color = useSelector((state) => state.theme);
  const isActiveDropdown = Boolean(activeDropdown?.match(/masterlist/gi));

  return (
    <Accordion
      defaultExpanded={/administrator/i.test(user.role)}
      elevation={0}
      square
      disableGutters
    >
      <AccordionSummary
        className={
          isActiveDropdown
            ? `FstoSidebarActiveDropdown-root ${color}`
            : `FstoSidebarDropdown-root  ${color}`
        }
        expandIcon={<ExpandIcon htmlColor="white" />}
      >
        <MasterlistIcon />
        <Typography variant="sidebar">Master List</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {masterlistItemsConfig.map((item) =>
          item.items ? (
            <Accordion
              key={item.label}
              elevation={0}
              square
              disableGutters
              className="FstoSidebarChildAccordionDetails-root"
            >
              <AccordionSummary
                className="FstoSidebarAccordionSummary-root"
                expandIcon={<ExpandIcon htmlColor="white" />}
              >
                <RadioButtonCheckedIcon className="FstoSidebarIcon-root" />
                <Typography variant="sidebarChildAccordionText">{item.label}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {item.items.map((subItem) => (
                  <RouterLink className="FstoSidebarLink-root" to={subItem.to} key={subItem.label}>
                    {subItem.label}
                  </RouterLink>
                ))}
              </AccordionDetails>
            </Accordion>
          ) : (
            <RouterLink className="FstoSidebarLink-root" to={item.to} key={item.label}>
              {item.label}
            </RouterLink>
          )
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default SidebarMasterlistDropdown;
